export enum PlanType {
  FREE = 'free',
  STANDARD = 'standard',
  PRO = 'pro',
  ENTERPRISE = 'enterprise',
  EMBED = 'embed',
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  PAST_DUE = 'past_due',
  TRIALING = 'trialing',
}

export interface SubscriptionDto {
  id: string;
  planType: PlanType;
  status: SubscriptionStatus;
  amount: number;
  currency: string;
  interval: 'month' | 'year' | null;
  currentPeriodEnd: string | null;
  stripeSubscriptionId?: string | null;
  cancelAtPeriodEnd?: boolean;
  scheduleId?: string | null;
  pendingPlan?: {
    planType: PlanType;
    amount: number;
    interval: 'month' | 'year';
  } | null;
  /** Whether cloud billing is enabled (has Stripe subscription with payment method) */
  cloudBillingEnabled?: boolean;

  // Cloud balance enforcement fields
  /** Warning status - 'low' when 0 < balance < 5, 'negative' when balance ≤ 0 */
  balanceWarning?: 'low' | 'negative' | null;
  /** Grace period end date (ISO string) - deadline before suspension */
  gracePeriodEnd?: string | null;
  /** Whether workspace is currently suspended due to negative balance */
  suspended?: boolean;
  /** Whether workspace can activate cloud features (balance > 0) */
  canActivateCloud?: boolean;
  /** Whether workspace can publish apps (balance > 0) */
  canPublish?: boolean;
}

export interface CreateCheckoutSessionDto {
  planType: PlanType.STANDARD | PlanType.PRO;
  interval: 'month' | 'year';
}

export interface CheckoutSessionResponse {
  url: string;
}

export interface PricingPlan {
  id: PlanType;
  name: string;
  description: string;
  monthlyPrice: number | string;
  yearlyPrice: number | string;
  features: string[];
  highlighted?: boolean;
  ctaText?: string;
}
